/**
 * Script loader for third-party analytics and tracking services
 * Only executes in production environment
 */

interface UserInfo {
  userId: string;
  userName: string;
  rfc: string;
  enterprise: string;
}

interface StoredUser {
  email: string;
  name: string;
}

interface StoredEnterprise {
  rfc: string;
  razon_social: string;
}

if (import.meta.env.MODE === 'production') {
  // Get user from Local Storage
  const userStorage = localStorage.getItem('user');
  let userInfo: UserInfo | undefined;

  // Check if user exists in Local Storage
  if (userStorage) {
    try {
      // If user exists, convert it to a JavaScript object
      const user: StoredUser = JSON.parse(userStorage);
      const enterpriseStorage = localStorage.getItem('enterprise');
      
      if (enterpriseStorage) {
        const enterprise: StoredEnterprise = JSON.parse(enterpriseStorage);
        userInfo = {
          userId: user.email,
          userName: user.name,
          rfc: enterprise.rfc,
          enterprise: enterprise.razon_social,
        };
      }
    } catch (error) {
      console.warn('Error parsing user or enterprise data from localStorage:', error);
    }
  }

  // Code to load HubSpot script (currently commented out)
  /*
  const scriptHubSpot = document.createElement('script');
  scriptHubSpot.type = 'text/javascript';
  scriptHubSpot.id = 'hs-script-loader';
  scriptHubSpot.async = true;
  scriptHubSpot.defer = true;
  scriptHubSpot.src = '//js.hs-scripts.com/45465579.js';
  document.body.appendChild(scriptHubSpot);
  */

  // Code to load first Google Tag Manager script (Google Analytics) - currently commented out
  /*
  const scriptGTag1 = document.createElement('script');
  scriptGTag1.src = 'https://www.googletagmanager.com/gtag/js?id=G-C95V057NZS';
  scriptGTag1.async = true;
  document.body.appendChild(scriptGTag1);
  */

  // Code to load second Google Tag Manager script (Google Ads) - currently commented out
  /*
  const scriptGTag2 = document.createElement('script');
  scriptGTag2.src = 'https://www.googletagmanager.com/gtag/js?id=AW-16507430486';
  scriptGTag2.async = true;
  document.body.appendChild(scriptGTag2);
  */

  // Code to execute Google Tag Manager scripts (Google Ads conversions) - currently commented out
  /*
  const inlineScript = document.createElement('script');
  inlineScript.textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'G-C95V057NZS');
    gtag('config', 'AW-16507430486');
    gtag('event', 'conversion', {'send_to': 'AW-16507430486/5ZzuCOe94Z8ZENbMrb89'});
  `;
  document.body.appendChild(inlineScript);
  */

  // Load SessionRewind script
  const scriptSessionRewind = document.createElement('script');
  scriptSessionRewind.textContent = `
    !function (o) {
      var w = window;
      w.SessionRewindConfig = o;
      var f = document.createElement("script");
      f.async = 1, f.crossOrigin = "anonymous",
      f.src = "https://rec.sessionrewind.com/srloader.js";
      var g = document.getElementsByTagName("head")[0];
      g.insertBefore(f, g.firstChild);
    }({
      apiKey: 'fIttkX78Iv1kCXxdBxN4hakzmmuJTd432H8Fxo9k',
      startRecording: true,
      ${userInfo ? `userInfo: ${JSON.stringify(userInfo)},` : ''}
    });
  `;
  document.body.appendChild(scriptSessionRewind);
}
